import { useCallback } from 'react'
import { useEvalEventBridge } from './eval/use-eval-event-bridge'
import { UPDATE_TYPES, type VibeEvent } from './wire'

/**
 * The eval consumer of the event fan-out — symmetric with the reducer and
 * canvas-sync: it filters its own events, so the wiring stays a pure fan-out
 * with zero update_type branches. Bridges into the shared Truman eval
 * subsystem via the dedicated vibe eval store.
 */
export const useEvalSink = () => {
  const { handleEvaluationUpdate } = useEvalEventBridge()

  type EvaluationUpdate = Parameters<typeof handleEvaluationUpdate>[0]

  return useCallback(
    (event: VibeEvent) => {
      if (event.update_type !== UPDATE_TYPES.EVALUATION_UPDATE) return
      // The bridge's contract is { payload: { eval_event_type, ... } } — the
      // wire guarantees that shape for evaluation_update; the payload cast is
      // the seam's single typed boundary.
      handleEvaluationUpdate({
        payload: (event.payload ?? {}) as EvaluationUpdate['payload'],
      })
    },
    [handleEvaluationUpdate],
  )
}
